<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <!-- Hero -->
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]" style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;"></div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-3xl">
        <a routerLink="/products/connectiq" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
          V Store <span class="text-varroc-accent">Marketplace &amp;</span> Redemption
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-2xl" data-aos="fade-up" data-aos-delay="200">
          V-Store is the in-app rewards marketplace where drivers redeem their Varroc Miles for exclusive partner offers, cashback deals, and lifestyle rewards creating a complete end-to-end loyalty experience.
        </p>
        <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
          <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all v_store_marketplace_partner_with_v_store_button">
            Partner with V-Store
          </a>
          <a routerLink="/products/connectiq/miles" class="border border-varroc-accent/40 font-semibold px-8 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all v_store_marketplace_explore_varroc_miles_button">
            Explore Varroc Miles
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Sticky Nav -->
  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <!-- Content -->
  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">

    <!-- Overview -->
    <section id="overview" class="section-anchor">
      <div class="grid md:grid-cols-2 gap-12 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">What Is V-Store</span>
          <h2 class="text-4xl font-black mt-3 mb-5">The Rewards Destination for Connected Drivers</h2>
          <p class="text-varroc-text-gray leading-relaxed mb-5">V-Store completes the loyalty loop started by Varroc Miles. It's the in-app marketplace where drivers convert their accumulated driving rewards into real-world value through a curated catalogue of partner offers, exclusive deals, and service discounts.</p>
          <p class="text-varroc-text-gray leading-relaxed">OEMs configure the store brand, partner catalogue, and featured campaigns  while V-Store handles all fulfilment, voucher delivery, and transaction management automatically.</p>
        </div>
        <div class="feature-card" data-aos="fade-left">
          <h3 class="text-white font-bold text-lg mb-5">Platform Highlights</h3>
          <div class="space-y-4">
            <div class="flex items-center gap-4">
              <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i class='bx bx-store-alt icon-gradient text-xl'></i>
              </div>
              <div>
                <div class="text-white font-semibold text-sm">OEM-Branded Experience</div>
                <div class="text-varroc-text-gray text-xs">White-labeled store inside the connected vehicle app</div>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i class='bx bx-link icon-gradient text-xl'></i>
              </div>
              <div>
                <div class="text-white font-semibold text-sm">Partner Integration</div>
                <div class="text-varroc-text-gray text-xs">Native API integration with brand and service partners</div>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i class='bx bx-mobile icon-gradient text-xl'></i>
              </div>
              <div>
                <div class="text-white font-semibold text-sm">Mobile-First Design</div>
                <div class="text-varroc-text-gray text-xs">Optimized for in-vehicle and mobile app contexts</div>
              </div>
            </div>
            <div class="flex items-center gap-4">
              <div class="w-10 h-10 bg-varroc-accent/15 rounded-lg flex items-center justify-center flex-shrink-0">
                <i class='bx bx-bar-chart-alt-2 icon-gradient text-xl'></i>
              </div>
              <div>
                <div class="text-white font-semibold text-sm">Redemption Analytics</div>
                <div class="text-varroc-text-gray text-xs">Real-time dashboard for offer performance and user trends</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- Features -->
    <section id="features" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Store Capabilities</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Key Features</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">Everything needed to run a high-engagement rewards marketplace inside a connected vehicle app.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let h of highlights; let i = index" class="feature-card flex items-start gap-4" data-aos="fade-up" [attr.data-aos-delay]="i * 60">
          <div class="w-10 h-10 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
            <i class='bx icon-gradient text-xl' [class]="h.icon"></i>
          </div>
          <div>
            <h3 class="text-white font-semibold text-sm mb-1">{{ h.label }}</h3>
            <p class="text-varroc-text-gray text-xs leading-relaxed">{{ h.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- Categories -->
    <section id="categories" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Offer Catalogue</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Reward Categories</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">A diverse and growing catalogue of partner offers across automotive, lifestyle, digital, and travel categories.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div *ngFor="let cat of categories; let i = index" class="feature-card flex items-start gap-4" data-aos="fade-up" [attr.data-aos-delay]="i * 60">
          <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center flex-shrink-0">
            <i class='bx icon-gradient text-2xl' [class]="cat.icon"></i>
          </div>
          <div>
            <h3 class="text-white font-bold text-sm mb-1">{{ cat.title }}</h3>
            <p class="text-varroc-text-gray text-xs leading-relaxed">{{ cat.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <!-- User Experience -->
    <section id="experience" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Redemption Flow</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Simple, Secure Redemption</h2>
        <p class="text-varroc-text-gray max-w-2xl mr-auto">A four-step redemption experience designed for speed, security, and driver satisfaction.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div *ngFor="let step of experienceSteps; let i = index" class="feature-card text-center" data-aos="fade-up" [attr.data-aos-delay]="i * 80">
          <div class="text-varroc-accent font-black text-3xl mb-3 opacity-40">{{ step.step }}</div>
          <h3 class="text-white font-bold text-base mb-2">{{ step.label }}</h3>
          <p class="text-varroc-text-gray text-sm">{{ step.desc }}</p>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <!-- <section class="text-center py-16 bg-gradient-to-r from-varroc-accent/10 via-varroc-dark to-varroc-accent/10 border border-varroc-accent/20 rounded-3xl" data-aos="fade-up">
      <h2 class="text-4xl font-black mb-4">Open the V-Store to Your Users</h2>
      <p class="text-varroc-text-gray text-lg mb-8 max-w-2xl mx-auto">Set up your brand's rewards marketplace in the connected vehicle app. Partner catalogue integration, campaign management, and analytics included.</p>
      <div class="flex flex-wrap gap-4 justify-center">
        <a routerLink="/contact-us" class="bg-varroc-accent text-white font-bold px-10 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all text-lg">Talk to Team</a>
        <a routerLink="/products/connectiq" class="border border-varroc-accent/40 font-semibold px-10 py-4 rounded-md hover:border-varroc-accent hover:bg-varroc-accent/10 transition-all text-lg">Back to ConnectIQ</a>
      </div>
    </section> -->

  </div>
</main>
